import { createContext, useCallback, useContext, useState } from 'react';

const WhatsAppContext = createContext({ isOpen: false, open: () => {}, close: () => {} });

export function WhatsAppProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <WhatsAppContext.Provider value={{ isOpen, open, close }}>
      {children}
    </WhatsAppContext.Provider>
  );
}

export function useWhatsApp() {
  return useContext(WhatsAppContext);
}

export default WhatsAppContext;
